// image compress
function compress(imgElem, maxSize, mimeType, quality) {
  maxSize = typeof maxSize !== 'undefined' ? maxSize : 2048;
  mimeType = typeof mimeType !== 'undefined' ? mimeType : "image/jpeg";
  quality = typeof quality !== 'undefined' ? quality : 85;

  var actWidth = imgElem.width;
  var actHeight = imgElem.height;

  var calcWidth;
  var calcHeight;

  if (actWidth >= actHeight) {
    if (actWidth > maxSize) {
      var ratio = maxSize / actWidth;
      calcWidth = actWidth * ratio;
      calcHeight = actHeight * ratio;
    } else {
      calcWidth = actWidth;
      calcHeight = actHeight;
    }
  } else {
    if (actHeight > maxSize) {
      var ratio = maxSize / actHeight;
      calcWidth = actWidth * ratio;
      calcHeight = actHeight * ratio;
    } else {
      calcWidth = actWidth;
      calcHeight = actHeight;
    }
  }

  var canvas = document.createElement("canvas");
  canvas.width = calcWidth;
  canvas.height = calcHeight;
  var context = canvas.getContext("2d");
  context.scale(calcWidth / actWidth, calcHeight / actHeight);
  context.drawImage(imgElem, 0, 0);

  return canvas.toDataURL(mimeType, quality / 100);
}

var ImageCropper = function (imageSelector) {

  function initCropper() {
    var image = $(imageSelector)[0];
    new Cropper(image, {
      viewMode: 1,
      dragMode: 'move',
      aspectRatio: 1,
      autoCropArea: 0.8
    });
  }

  this.getImageSelector = function () {
    return imageSelector;
  };

  function getCropper() {
    return $(imageSelector)[0].cropper;
  }

  function destroyCropper() {
    var cropper = getCropper();
    if (cropper != null) {
      cropper.destroy();
    }
  }

  this.getCroppedImage = function () {
    var canvas = getCropper().getCroppedCanvas({ width: 600, height: 600 });
    var imgData = canvas.toDataURL("image/png");
    imgData = imgData.slice(imgData.indexOf(',') + 1);
    console.log(imgData);
    return imgData;
  };

  this.uploadImage = function () {
    var canvas = getCropper().getCroppedCanvas({ width: 600, height: 600 });
    var imgData = canvas.toDataURL("image/png");
    var img = $(imageSelector)[0];
    img.src = imgData;
    imgData = imgData.slice(imgData.indexOf(',') + 1);
    // call to native function - only works within the app
    JSInterface.onSavePicture(imgData);
  };

  // capture image from device camera
  this.captureImage = function () {
    destroyCropper();
    // call to native function - only works within the app
    JSInterface.captureImage();
  };

  // load image from gallery
  this.loadImage = function () {
    destroyCropper();
    // call to native function - only works within the app
    JSInterface.loadImage();
  };

  this.setImage = function (imgData) {
    if (imgData == null) {
      imgData = JSInterface.getImageData();
    }
    $(imageSelector).attr('src', imgData);
    initCropper();
  };
};